import './header.scss'

/*!
 * trap focus
 * @link https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
 */
function trapFocus(element) {
    var focusableEls = element.querySelectorAll('a[href]:not([disabled]):not([class*=hidden]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'),
        firstFocusableEl = focusableEls[0],
        lastFocusableEl = focusableEls[focusableEls.length - 1];

    element.addEventListener('keydown', function(e) {
        var isTabPressed = (e.key === 'Tab');

        if (!isTabPressed) {
            return;
        }

        // shift + tab
        if ( e.shiftKey ) {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }

        // tab
        } else {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}


const mainMenuList = document.getElementById('menu-list');

const MOBILE_MENU_MAX_WIDTH = 959;

function isMobileMenu() {
    return document.body.clientWidth <= MOBILE_MENU_MAX_WIDTH;
}

/*!
* menuManager
* @version v1.0.2
* @copyright Tussendoor internet & marketing
*/
var oldScrollY = window.scrollY;
function scrollManager() {
    let html = document.documentElement;

    if (!mainMenuList) return;

    // hide header after 200px
    // we also check if the menu is not hovered
	if (window.scrollY >= 200 && mainMenuList.classList.contains('hover') === false) {
        html.classList.add('they-see-me-scrolling');
	} else {
        html.classList.remove('they-see-me-scrolling');
	}

    // determine scroll direction
    if(oldScrollY < window.scrollY){
        // scroll down
        html.classList.add('scroll-down');
        html.classList.remove('scroll-up');
    } else if (window.scrollY === 0) {
        // scrolled to top
        html.classList.remove('scroll-up');
    } else if (oldScrollY > window.scrollY && oldScrollY - window.scrollY > 10) {
        // scroll up
        html.classList.add('scroll-up');
        html.classList.remove('scroll-down');
    }

    oldScrollY = window.scrollY;
}

window.addEventListener('scroll', scrollManager, false);

document.addEventListener('DOMContentLoaded', function() {
    var mainMenu = document.getElementById('menu-list');
    if (!isMobileMenu()) {
        mainMenu.scrollBy(70, 0);
    }
});

function menuScroller(e) {
    const target = e.target;
    var mainMenu = document.getElementById('menu-list');
    var scrollValue = window.innerWidth * 0.2; // 10% of the viewport width
    let direction = target.dataset.direction === 'left' ? -scrollValue : scrollValue;

    mainMenu.parentElement.classList.add('activated');

    mainMenu.scrollBy({
        top: 0,
        left: direction,
        behavior: 'smooth'
    });
}


/*!
 * menu-controler
 * @version v1.0.2
 */
function menuControler(e) {
    if (isMobileMenu()) {
        const navigation = document.getElementById('site-navigation');
        const mainMenuList = document.getElementById('menu-list');
        const toggleButton = e.target.closest('.js--toggle-menu');
        const html = document.documentElement;
        const focusableEls = navigation.querySelectorAll('a[href]:not([disabled]):not([class*=hidden]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        const firstFocusableEl = focusableEls[0];

        if (!navigation || !mainMenuList || !toggleButton || !firstFocusableEl) return;

        // trapfocus inside menu
        trapFocus(navigation);

        toggleButton.classList.toggle('active');
        navigation.classList.toggle('active');
        mainMenuList.classList.toggle('active');

        if (html.classList.contains('dash-open')) {
            dashboardCloser();
        } else {
            html.classList.toggle('scroll-is-disabled');
        }

        html.classList.toggle('menu-open');
        firstFocusableEl.focus();
    }
}

function mainMenuControler(e) {
    // On desktop the dropdowns are hover/focus driven, so a click has to follow
    // the link instead of pinning the dropdown open.
    if (!isMobileMenu()) return;

    var trigger = e.target.closest('.m-menu__link--main'),
        parent = trigger ? trigger.closest('.m-menu__item') : null,
        html = document.documentElement;

    if (!trigger || !parent || !parent.lastElementChild) return;

    e.preventDefault();
    html.classList.toggle('scroll-is-disabled');
    parent.classList.toggle('active');
    parent.lastElementChild.classList.toggle('active');
}

/*!
 * submenu-controler
 * @version v1.0.1
 */
function subMenuControler(e) {
    if (!isMobileMenu()) return;

    var trigger = e.target.closest('.m-menu__link--sub'),
        parent = trigger ? trigger.closest('.m-menu__item') : null;

    if (!trigger || !parent || !parent.lastElementChild) return;

    e.preventDefault();
    parent.classList.toggle('active');
    parent.lastElementChild.classList.toggle('active');
}

/*!
 * menu-closer
 * @version v1.0.1
 */
function menuCloser() {
    if (isMobileMenu()) {
        var menu = document.getElementById('site-navigation'),
            btn = document.querySelector('.js--toggle-menu'),
            html = document.documentElement;

        if (!menu) return;

        btn.classList.remove('active');
        menu.classList.remove('active');
        html.classList.remove('menu-open');

    }
}

// event listener
const siteNavigation = document.getElementById('site-navigation');
document.addEventListener('click', function (e) {
    if (e.target.closest('.js--toggle-menu')) {
        menuControler(e);
    }
}, false);

if (siteNavigation) {
    siteNavigation.addEventListener('click', function (e) {
        if (e.target.closest('.menu-item-has-children > .m-menu__link--main')) {
            mainMenuControler(e);
        }

        if (e.target.closest('.menu-item-has-children > .m-menu__link--sub')) {
            subMenuControler(e);
        }

        if (e.target.closest('.js--menu-previous')) {
            menuReturner(e);
        }

        if (e.target.closest('.js--main-nav')) {
            menuScroller(e);
        }
    }, false);
}

function menuReturner(e) {
    const parentMenu = e.target.closest('.m-menu__level');
    if (!parentMenu) return;

    parentMenu.classList.remove('active');
}

function positionMenuCaret(menuItem) {
    if (isMobileMenu() || !menuItem || !menuItem.classList.contains('m-menu__mega')) {
        return;
    }

    var link = menuItem.querySelector(':scope > .m-menu__link--main');
    var panel = menuItem.querySelector(':scope > .m-menu__level--0');
    var headerInner = document.querySelector('.o-header__inner');

    if (!link || !panel || !headerInner) return;

    var linkRect = link.getBoundingClientRect();
    var linkCenter = linkRect.left + (linkRect.width / 2);
    var innerRect = headerInner.getBoundingClientRect();
    var panelWidth = Math.min(1020, innerRect.width);
    var panelLeft = innerRect.left + ((innerRect.width - panelWidth) / 2);

    panel.style.setProperty('--menu-caret-left', (linkCenter - panelLeft) + 'px');
}

function initMenuCarets() {
    if (isMobileMenu()) return;

    var megaMenuItems = document.querySelectorAll('.m-menu__item--main.m-menu__mega.menu-item-has-children');

    megaMenuItems.forEach(function(menuItem) {
        menuItem.addEventListener('mouseenter', function() {
            positionMenuCaret(menuItem);
        });

        menuItem.addEventListener('focusin', function() {
            positionMenuCaret(menuItem);
        });
    });

    window.addEventListener('resize', function() {
        document.querySelectorAll('.m-menu__item--main.m-menu__mega.menu-item-has-children:hover, .m-menu__item--main.m-menu__mega.menu-item-has-children:focus-within').forEach(function(menuItem) {
            positionMenuCaret(menuItem);
        });
    });
}

initMenuCarets();

/*!
 * Toggle hover class on main menu when mouse is inside
 * @version v1.0.1
 */
(function() {
    var mainMenuItems = document.querySelectorAll('.menu__item--main');
    mainMenuItems.forEach(function(element) {

        element.addEventListener('mouseover', function(event) {
            mainMenuList.classList.add('hover');
        });

        element.addEventListener('mouseout', function(event) {
            // Check if the mouse is still within the parent element or its children
            var isHoverStillWithin = element.contains(event.relatedTarget);

            if (!isHoverStillWithin) {
                mainMenuList.classList.remove('hover');
            }
        });

    });
})();

